// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__32ay4","footer":"ModalFilter_footer__1YSRp"};